<template>
  <div>
    <q-btn id="thebtn"
        :loading="loading"
        :disable="disable"
        :noCaps="noCaps"
        :noWrap="noWrap"
        :label="label"
        :outline="outline"
        :flat="flat"
        :round="round"
        :push="push"
        :size="size"
        :color="color"
        :textColor="textColor"
        :glossy="glossy"
        :dense="dense"
        :noRipple="noRipple"
        @click="onClick"
        v-touch-hold:400="onHold"
        class="q-btn-dropdown q-btn-dropdown-simple"
    >
      <q-icon :name="icon" size="20px"></q-icon>
      <span v-if="!showing">&hellip;</span>
    </q-btn>
    <div>
    <q-popover
        ref="popover"
        :disable="disable"
        v-model="showing"
        anchor="bottom right"
        self="top right"
        fit
        :class="contentClass"
        :style="contentStyle"
    >
      <slot></slot>
    </q-popover>
    </div>
  </div>
</template>

<script>
import BtnMixin from './btn-mixin';

export default {
  name: 'BtnHold',
  mixins: [BtnMixin],
  props: {
    contentClass: [Array, String, Object],
    contentStyle: [Array, String, Object],
  },
  data() {
    return {
      showing: false,
    };
  },
  beforeDestroy() {
    document.removeEventListener('touchstart', this.stop, { once: true });
  },
  methods: {
    onClick(e) {
      if (!this.disable) {
        this.$emit('click', e);
      }
    },
    onHold() {
      window.navigator.vibrate(50);
      this.showing = true;
      document.addEventListener('touchstart', this.stop, { once: true, capture: true });
    },
    stop(e) {
      console.log('stop', e.target.id, e.target.parentElement.id, e.target.parentElement.parentElement.id);
      if (e.target.id === 'thebtn' ||
        e.target.parentElement.id === 'thebtn' ||
        e.target.parentElement.parentElement.id === 'thebtn') {
        e.stopPropagation();
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/btn-hold.vue